var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2107 23.0597L17.1373 18.9964C13.264 21.9157 7.80948 21.4285 4.5148 17.869C1.22012 14.3095 1.1552 8.83372 4.36458 5.19715C7.57396 1.56058 13.0154 0.944248 16.9568 3.77087C20.8983 6.59749 22.0597 11.9491 19.6446 16.1553C19.5553 16.3103 19.4626 16.4614 19.3656 16.6104L18.4302 16.0025C18.5163 15.8709 18.598 15.736 18.6766 15.5996C20.8418 11.8331 19.7683 7.03645 16.2042 4.55224C12.6401 2.06804 7.76826 2.72078 4.98381 6.05559C2.19936 9.3904 2.42639 14.3005 5.50669 17.3641C8.58698 20.4278 13.4982 20.6282 16.8179 17.8257C17.0396 17.6384 17.3677 17.6519 17.5734 17.8567L22 22.2723L21.2107 23.0597Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4162a25bd9c0b3a25a71c0225425e111bc4cfbee9010f26776542f89096df05b.svg";
export { ForwardRef as ReactComponent };